export default __webpack_public_path__ + "static/media/madden23.67a56e88.jpeg";